import React, { useState } from 'react';

import { Switch, Form, Divider, Select, InputNumber, Flex, Space, Col } from 'antd';

export interface IUserConsignee {
    code: number;
    userId: string;
    isActive: boolean;
}

interface IUserClients {
    userConsignees: Array<IUserConsignee>;
    isViewOnly: boolean;
    onChange: (e: Array<IUserConsignee>) => void;
}

const UserClients = (props: IUserClients) => {
    const { userConsignees, isViewOnly, onChange } = props;

    return (
        <div>
            <Form.Item wrapperCol={{ span: 24 }}>
                <Divider style={{ marginBottom: 0 }} titlePlacement='left'>
                    Клиенты
                </Divider>
            </Form.Item>

            <Flex wrap gap='middle'>
                {userConsignees.map((c) => {
                    return (
                        <Form.Item
                            key={c.code}
                            label={c.code}
                            style={{ marginBottom: 0 }}
                            labelCol={{ span: 11 }}
                            wrapperCol={{ xs: 6 }}
                        >
                            <Switch
                                size='small'
                                disabled={isViewOnly}
                                defaultChecked={c.isActive}
                                onChange={(value) => {
                                    const entities = [...userConsignees];

                                    const entity = entities.find((e) => e.code === c.code);

                                    if (entity) {
                                        entity.isActive = value;
                                        onChange([...entities]);
                                    }
                                }}
                            />
                        </Form.Item>
                    );
                })}
            </Flex>
        </div>
    );
};

export default UserClients;
